import React, { useState } from "react";
import { motion } from "framer-motion";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";

const faqs = [
  {
    question: "Combien de temps faut-il pour créer mon site ?",
    answer:
      "En moyenne, une landing page prend 5 à 7 jours et un site vitrine 10 à 15 jours.",
  },
  {
    question: "Puis-je modifier mon site après la livraison ?",
    answer:
      "Oui, mais toute modification après validation sera facturée selon le besoin.",
  },
  {
    question: "Comment se passe le paiement ?",
    answer:
      "Un acompte de 50% est requis avant de commencer, le reste à la livraison.",
  },
  {
    question: "Puis-je avoir un site e-commerce ?",
    answer:
      "Mon offre actuelle concerne les sites vitrines et landing pages. Pour une boutique en ligne, contactez-moi !",
  },
];

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="container-fluid py-5" id="faq">
      <div className="container">
        <h1 className="text-center mb-4 fw-bold">
          FAQ - Vos Questions, Nos Réponses
        </h1>
        <div className="row">
          <div className="col-12">
            {faqs.map((faq, index) => (
              <motion.div
                key={index}
                className="faq-item p-3 my-2 rounded shadow-sm"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.3, delay: index * 0.1 }}
              >
                <div
                  className="faq-question d-flex justify-content-between align-items-center fw-bold text-light"
                  onClick={() => toggleFAQ(index)}
                  style={{ cursor: "pointer" }}
                >
                  {faq.question}
                  {openIndex === index ? <FaChevronUp /> : <FaChevronDown />}
                </div>
                {openIndex === index && (
                  <motion.div
                    className="faq-answer mt-2"
                    initial={{ opacity: 0, height: 0 }}
                    animate={{ opacity: 1, height: "auto" }}
                    transition={{ duration: 0.3 }}
                  >
                    {faq.answer}
                  </motion.div>
                )}
              </motion.div>
            ))}
          </div>
        </div>
        <div className="text-center mt-4">
          <h2>Encore des questions ?</h2>
          <p>Réservez un appel avec moi pour que je puisse y répondre.</p>
          <motion.button
            className="btn btn-primary rounded-pill px-4 py-2 "
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
          >
            <a
              target="blank"
              className="text-decoration-none white-color"
              href="https://tally.so/r/m6vN5o"
            >
              Contactez-moi
            </a>
          </motion.button>
        </div>
      </div>
    </div>
  );
};

export default FAQ;
